<template>
  <div>
    <div v-for="(basketItem) in viewData.basket" v-bind:key="basketItem.pd_id" class="product_container" id="18101366_product_area">
      <p class="rew19_tit">{{basketItem.pd_name_kr}}</p>
      <ul class="rew19_payment_items">
        <li>
          <em class="rew19_gTit rew19_point">정기구매가</em>
          <span class="rew19_gDetail">
            <strong>{{$fmt.WON(basketItem.pd_amt1)}}</strong>원
          </span>
        </li>
        <li>
          <em class="rew19_gTit">수량</em>
          <span class="rew19_gDetail">{{basketItem.pd_count}}</span>
        </li>
        <li>
          <em class="rew19_gTit">합계</em>
          <span class="rew19_gDetail">
            <strong class="rew19_bigPay">{{$fmt.WON(basketItem.total_amt)}}</strong>원
          </span>
        </li>
      </ul>
      <div v-for="(agmInfoItem) in basketItem.agm_info" v-bind:key="agmInfoItem.id" class="rew19_payment_product" v-show="basketItem.agm_info.length > 0">
        <p class="rew19_ptit">
          <em class="rew19_gTit">{{agmInfoItem.agm_name}}</em>
          <span class="rew19_gDetail">{{agmInfoItem.agm_code}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{agmInfoItem.agm_detail}}</span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import * as ErrMsg from "@/utils/error_msg";
import * as Common from "@/utils/common";
import * as Const from "@/utils/const";

const INIT_VIEW_BASKET_DATA = {
  basket: [],
  payment_amt: "", 
  total_pv: "",
  total_cv: "",
  total_sb: ""
};

export default {
  name: "OrderProductList",
  props: {
    mode: {
      type: String,
      default: ""
    }
  },
  data() {
    return {

      viewData: {
        ...INIT_VIEW_BASKET_DATA
      }
    };
  },
  mounted() {
    let _this = this;
  },
  methods: {
    getData() {
      let _this = this;
      switch (_this.mode) {
      case Const.ARO_BASKET_MODE:
      case Const.ARO_15_BASKET_MODE:
        _this.getBasket();
        break;
      case Const.ARO_NTC_BASKET_MODE:
        _this.getNtcBasket();
        break;
      }
    },
    apiGetBasket() {
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/get_cart`, {
        params: {
          //memberId : memberId
        }
      });
    },
    apiGetNtcBasket() {
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/ntc/carts`, {
        params: {
          //memberId : memberId
        }
      });
    },

    getBasket(){
      let _this = this;

      _this.$showLoading();
      _this.apiGetBasket().then(basketRes => {
          if (basketRes.status === 200 && basketRes.data.status === "0000") {
            let list = basketRes.data;
            if(_this.mode == Const.ARO_BASKET_MODE){
              if(list.payment_amt == "0"){
                _this.$dialogs.alert("결제 정보가 올바르지 않습니다.", {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {
                _this.$router.push(`${_this.$aroBasePath}/basket`);  
                });
                return;
              }

              if(list.basket_orderyn != "Y"){
                _this.$dialogs.alert("정기구매는 6만원 이상 결제하셔야 합니다.").then(res => {
                  _this.$router.push(`${_this.$aroBasePath}/basket`);  
                });
                return;  
              }

              let basketList = [];
              for(var i=0; i<list.basket.length; i++){
                let basketItem = {};
                let agmInfoList = [];
                //커스텀 프로덕트 키트일 경우
                if(list.basket[i].agm_info != undefined){
                    agmInfoList = [...list.basket[i].agm_info];
                }
                basketItem = {
                  agm_info: agmInfoList,
                  pd_id: list.basket[i].pd_id,
                  pd_name_kr: list.basket[i].pd_name_kr,
                  pd_count: list.basket[i].pd_count,
                  pd_amt1: list.basket[i].pd_amt1,
                  total_amt: list.basket[i].total_amt,
                  pd_count :list.basket[i].pd_count,
                  brand :list.basket[i].brandName,
                  category :list.basket[i].categoryName,
                  isSoldOut :list.basket[i].isSoldOut 
                }
                basketList.push(basketItem);
              }
              _this.viewData.basket =[...basketList];
              _this.viewData.payment_amt = list.payment_amt;
              _this.viewData.total_pv = list.total_pv;
              _this.viewData.total_cv = list.total_cv;
              _this.viewData.total_sb = list.total_sb;
            }else if(_this.mode == Const.ARO_15_BASKET_MODE){
              let basketList = [];
              for(var i=0; i<list.basketUspanList.length; i++){
                let basketItem = {};
                basketItem = {
                  pd_id: list.basketUspanList[i].pd_id,
                  pd_name_kr: list.basketUspanList[i].pd_name_kr,
                  pd_count: list.basketUspanList[i].pd_count,
                  pd_amt1: list.basketUspanList[i].pd_amt3,
                  total_amt: list.basketUspanList[i].pd_amt3,
                  pd_count :list.basketUspanList[i].pd_count,
                  brand :list.basketUspanList[i].brandName,
                  category :list.basketUspanList[i].categoryName,
                  isSoldOut :list.basketUspanList[i].isSoldOut 
                }
                basketList.push(basketItem);
              }
              _this.viewData.basket = [...basketList];
              _this.viewData.payment_amt = list.uspan_payment_amt;
              _this.viewData.total_pv = list.uspan_total_pv;
              _this.viewData.total_cv = list.uspan_total_cv;
              _this.viewData.total_sb = list.uspan_total_sb;
            }
            _this.$emit('setData', true, _this.viewData);
          }else{
            _this.$dialogs.alert(basketRes.data.message, {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {
            _this.$router.push(`${_this.$aroBasePath}/basket`);
            });
          }
        })
        .catch(() => {
          //TODO: 알수 없는 오류
          _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {
          _this.$router.push(`${_this.$aroBasePath}/basket`);
          });
        })
        .finally(() => {
          //hide loading
          _this.$hideLoading();
        });
    },
      getNtcBasket(){
      let _this = this;

      _this.$showLoading();
      _this.apiGetNtcBasket().then(basketRes => {
          if (basketRes.status === 200 && basketRes.data.status === "0000") {
            let list = basketRes.data;
            
              if(list.payment_amt == "0"){
                _this.$dialogs.alert("결제 정보가 올바르지 않습니다.", {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {
                _this.$router.push(`${_this.$aroBasePath}/basket`);  
                });
                return;
              }

              let basketList = [];
              for(var i=0; i<list.basketNtc.length; i++){
                let basketItem = {};
               
                basketItem = {
                  pd_id: list.basketNtc[i].pd_id,
                  pd_name_kr: list.basketNtc[i].pd_name_kr,
                  pd_count: list.basketNtc[i].pd_count,
                  pd_amt1: list.basketNtc[i].pd_amt1,
                  total_amt: list.basketNtc[i].total_amt,
                  pd_count :list.basketNtc[i].pd_count,
                  brand :list.basketNtc[i].brandName,
                  category :list.basketNtc[i].categoryName
                }
                basketList.push(basketItem);
              }
              _this.viewData.basket = [...basketList];
              _this.viewData.payment_amt = list.payment_amt;
              _this.viewData.total_pv = list.total_pv;
              _this.viewData.total_cv = list.total_cv;
              _this.viewData.total_sb = list.total_sb;
            
            
            _this.$emit('setData', true, _this.viewData);
          }else{
            _this.$dialogs.alert(basketRes.data.message, {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {
            _this.$router.push(`${_this.$aroBasePath}/basket`);
            });
          }
        })
        .catch(() => {
          //TODO: 알수 없는 오류
          _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {
          _this.$router.push(`${_this.$aroBasePath}/basket`);
          });
        })
        .finally(() => {
          //hide loading
          _this.$hideLoading();
        });
    },
  }
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/payment/OrderProductList.vue